module.exports = __webpack_public_path__ + "static/media/14.9df17dcf.jpeg";